import React from 'react';
import classNames from 'classnames';
import { TitleText } from 'components/Content/Atoms/TitleText';
import { Icon } from 'components/Atoms/Icon/Icon';
import styles from './NotificationSignup.module.scss';

interface Props {
  title: string;
  bodyText: string;
  showIllustration: boolean;
  hasBackgroundContainer: boolean;
  children: React.ReactNode;
}

export function NotificationSignupCard({ title, bodyText, showIllustration, hasBackgroundContainer, children }: Props) {
  const hasBodyText = !!bodyText?.trim();

  return (
    <div
      className={classNames(styles.card, {
        [styles.withBackground]: hasBackgroundContainer,
        [styles.noPadding]: !showIllustration && !hasBackgroundContainer,
      })}
    >
      <div className={classNames(styles.cardContent, { [styles.noBodyText]: !hasBodyText })}>
        {showIllustration && <Icon name="communicationPreferences" />}
        {/*
         * Grouped so the title and its body text sit 8px apart like every other block, without
         * tightening `.cardContent`'s 16px gap, which also spaces the signup form below.
         */}
        <div className={styles.headingGroup}>
          <TitleText text={title} flush />
          {hasBodyText && <p className={styles.bodyText}>{bodyText}</p>}
        </div>
        {children}
      </div>
    </div>
  );
}
